<template>
    <div>
      <!-- <div v-if="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null"
        style="margin-bottom: 16px !important;">
        <v-img
          contain
          width="100%"
          height="auto"
          alt="umb"
          :src="form.kop_surat_url_image">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular
                indeterminate
                :color="set_color">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>

      <div
        :style="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null ? `padding: 0px 38px 0px 38px;` : 'padding: 38px;'"> -->
        <v-card-text
          class="black--text py-2">
          <div class="text-center body-1 font-weight-bold mb-5" style="margin-bottom: 20px; text-align: center; font-weight: bold;">
            NOTULEN {{ selected.preview.template_meta_json_object.judul !== '' ? selected.preview.template_meta_json_object.judul : '__________' }}
          </div>
          <v-row>
            <v-col cols="12" md="7">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Hari, Tanggal
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  :
                  <span v-if="selected.preview.template_meta_json_object.tanggal_rapat !== '' && selected.preview.template_meta_json_object.tanggal_rapat !== null">
                    {{ selected.preview.template_meta_json_object.tanggal_rapat | day }}, {{ selected.preview.template_meta_json_object.tanggal_rapat | fulldate }}
                  </span>
                  <span v-else>
                    ___________________________
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Jenis Rapat
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.jenis_rapat !== '' ? selected.preview.template_meta_json_object.jenis_rapat : '__________' }}
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Lokasi Rapat
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.lokasi_rapat !== '' ? selected.preview.template_meta_json_object.lokasi_rapat : '__________' }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="5">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0 pl-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Waktu Rapat
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.waktu_rapat !== '' ? selected.preview.template_meta_json_object.waktu_rapat : '__________' }}
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0 pl-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Tadarus Al-Quran
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.tadarus !== '' ? selected.preview.template_meta_json_object.tadarus : '__________' }}
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0 pl-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Peserta Rapat
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.peserta !== '' ? selected.preview.template_meta_json_object.peserta : '__________' }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <div
            class="mt-8"
            style="margin-top: 8px !important;">

            <table style="border-collapse: collapse; width: 100%;">
              <tr>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  No
                </th>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  Pokok Bahasan
                </th>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  Tindak Lanjut
                </th>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  Waktu
                </th>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  PIC
                </th>
                <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                  Hasil Tidak Lanjut
                </th>
              </tr>

              <tr v-for="(item, index) in selected.preview.template_meta_json_object.pembahasan" :key="index">
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: center;">
                  {{ index + 1 }}
                </td>
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                  {{ item.pokok }}
                </td>
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                  {{ item.tindak }}
                </td>
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                  {{ item.waktu }}
                </td>
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                  {{ item.pic }}
                </td>
                <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                  {{ item.hasil }}
                </td>
              </tr>
            </table>

          </div>

          <v-row
            justify="end"
            class="mt-8"
            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
            <v-col
              cols="12"
              md="6"
              class="text-center"
              style="text-align: right !important;">
              <div>
                Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
              </div>

              <div
                class="mb-16"
                style="margin-bottom: 64px !important;">
                {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
              </div>

              <div>
                {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      <!-- </div>

      <div v-if="form.kop_surat_url_image_footer !== '' && form.kop_surat_url_image_footer !== null"
        style="margin-top: 16px !important;">
        <v-img
          style="position: absolute; bottom: 0;"
          contain
          width="100%"
          height="auto"
          alt="umb"
          :src="form.kop_surat_url_image_footer">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular
                indeterminate
                :color="set_color">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div> -->
    </div>
  </template>

  <script>
    import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        selected: {
          type: Object,
          default: {}
        },
        // units: {
        //   type: Array,
        //   default: []
        // },
        process: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,

            range: false
          },

          time: {
            pukul: false
          },
        }
      },
      components: {

      },
      watch: {

      },
      computed: {
        user () {
          return this.$store.state.user
        },

        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },

        configHeaders () {
          return this.headers.filter(header => !header.hide)
        },

        // formattedDate: {
        //   get () {
        //     return (this.selected.preview.template_meta_json_object.tanggal && this.selected.preview.template_meta_json_object.tanggal.length === 10) ? moment(this.selected.preview.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.selected.preview.template_meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.selected.preview.template_meta_json_object.tanggal = newDate
        //     }
        //   }
        // },

        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {

      },
      methods: {

      }
    }
  </script>
